import React from 'react';

import CountryInfo from '../CountryInfo';

const SUPPORT_SECTION = {
    title: 'Support Package for Irish Businesses',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    €200m Strategic Banking Corporation of Ireland working
                    capital scheme for businesses deemed to be significantly
                    impacted.
                </li>
                <li>
                    Up to €1.5m loans made available at reduced rates, with the
                    first €500,000 unsecured.
                </li>
                <li>
                    Another €200m package available, includes a rescue and
                    restructuring scheme through Enterprise Ireland for
                    vulnerable but viable firms that need to restructure or
                    transform their business.
                </li>
                <li>
                    Credit guarantee scheme through major banks, with loans of
                    up to €1m being made available at terms of up to seven
                    years.
                </li>
                <li>
                    Maximum available amount for immediate loans increase from
                    €25,000 to €50,000 for sole traders & companies with up to
                    nine employees in need of microfinancing.
                </li>
                <li>
                    Local Enterprise Offices in every county will be providing
                    vouchers from €2,500 up to €10,000 – with 50:50 match
                    funding.
                </li>
                <li>
                    Short time work support (income support payment for
                    employees)
                </li>
                <li>
                    COVID-19 Pandemic Unemployment Payment. The payment has a
                    simple one–page application form and will be paid for a
                    period of 6 weeks at a flat rate payment of €203 per week
                    for jobseekers. It is designed to quickly deliver a social
                    welfare payment to the unemployed and provide income
                    security during this 6-week period. Application link below.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Government reveals financial support for businesses hit by coronavirus',
            url: 'https://www.siliconrepublic.com/companies/business-coronavirus-support-ireland',
        },
        {
            title: 'SME Credit Guarantee Scheme (CGS) Information',
            url: 'https://sbci.gov.ie/schemes/sme-credit-guarantee-scheme-cgs',
        },
        {
            title: 'AIB Application for SME Credit Guarantee Scheme (CGS)',
            url: 'https://business.aib.ie/products/finance-and-loans/credit-guarantee-scheme',
        },
        {
            title: 'Bank of Ireland Application for Business loans',
            url: 'https://businessbanking.bankofireland.com/credit/business-loans/',
        },
        {
            title: 'Find Your Local Enterprise Office to apply for vouchers',
            url: 'https://www.localenterprise.ie/Portal/Find-Your-Local-Enterprise-Office/',
        },
        {
            title: 'Short Time Work Support Information and Application',
            url: 'https://www.gov.ie/en/service/c20e1b-short-time-work-support/?referrer=/stws/',
        },
        {
            title: 'COVID-19 Pandemic Unemployment Payment Information and Application',
            url: 'https://www.gov.ie/en/service/be74d3-covid-19-pandemic-unemployment-payment/',
        },
    ],
};

const BCAP_SECTION = {
    title: 'Bank of Ireland Response',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">For Businesses</p>
            <ul>
                <li>Business customers</li>
                <li>Emergency working capital</li>
                <li>Payment flexibility on loan facilities</li>
                <li>
                    Provision of trade finance and foreign currency products
                </li>
                <li>Prioritisation of loan decisions</li>
            </ul>
            <br />
            <p className="eds-text-bl eds-l-mar-bot-4">For Peronal Customers</p>
            <ul>
                <li>Mortgage payment breaks and flexible arrangements</li>
                <li>Personal loan payment breaks or flexible arrangements</li>
                <li>
                    Contactless fees have been waived (16.03.20) for the
                    duration of the public health emergency
                </li>
                <li>
                    For those impacted by travel disruption, BOI will buy back
                    foreign currency at the rate it was sold, ensuring customers
                    won’t be at a financial loss.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Message from Bank of IrelandL Coronavirus Update',
            url: 'https://www.bankofireland.com/coronavirus-update/',
        },
        {
            title: 'Mortgage Flexi-Options and Application',
            url: 'https://personalbanking.bankofireland.com/borrow/mortgages/articles/mortgage-flexi-options/#panel1',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Ireland',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Ireland has multiple different financial assistance options
            available. Please look over this information and follow up as
            appropriate.
        </p>
    ),
    sections: [SUPPORT_SECTION, BCAP_SECTION],
};

const IrelandInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default IrelandInfo;
